class KlaviyoNewsletterForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.message = this.querySelector('[data-klaviyo-message]');
    this.submitButton = this.form?.querySelector('[type="submit"]');

    if (!this.form || this.form.dataset.klaviyoInitialized === 'true') return;

    this.form.dataset.klaviyoInitialized = 'true';
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();

    if (!this.form.checkValidity()) {
      this.form.reportValidity();
      return;
    }

    const formData = new FormData(this.form);
    const email = String(formData.get('email') || '').trim();
    const honeypot = String(formData.get('website') || '').trim();
    const companyId = this.dataset.companyId?.trim();
    const listId = this.dataset.listId?.trim();

    // Silently accept automated submissions caught by the honeypot.
    if (honeypot) {
      this.showSuccess();
      return;
    }

    if (!companyId || !listId) {
      console.error('Klaviyo newsletter is missing a public Site ID or list ID.');
      this.showError();
      return;
    }

    this.setLoading(true);
    this.clearMessage();

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                locale: this.dataset.locale || undefined,
                location: {
                  country: this.dataset.countryName || '',
                },
                subscriptions: {
                  email: {
                    marketing: {
                      consent: 'SUBSCRIBED',
                    },
                  },
                },
                properties: {
                  'Shopify Country Code': this.dataset.countryCode || '',
                  'Signup Source': 'Footer newsletter',
                },
              },
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId,
            },
          },
        },
      },
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2026-07-15',
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) throw new Error(`Klaviyo subscription failed with status ${response.status}`);

      this.form.reset();
      this.showSuccess();
    } catch (error) {
      console.error(error);
      this.showError();
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(isLoading) {
    if (!this.submitButton) return;
    this.submitButton.disabled = isLoading;
    this.submitButton.setAttribute('aria-busy', String(isLoading));
  }

  clearMessage() {
    if (!this.message) return;
    this.message.textContent = '';
    this.message.classList.remove('newsletter-form__message--success');
  }

  showSuccess() {
    if (!this.message) return;
    this.message.textContent = this.querySelector('[data-klaviyo-success]')?.content.textContent.trim() || '';
    this.message.classList.add('newsletter-form__message--success');
  }

  showError() {
    if (!this.message) return;
    this.message.textContent = this.querySelector('[data-klaviyo-error]')?.content.textContent.trim() || '';
    this.message.classList.remove('newsletter-form__message--success');
  }
}

if (!customElements.get('klaviyo-newsletter-form')) {
  customElements.define('klaviyo-newsletter-form', KlaviyoNewsletterForm);
}
